import CloseIcon from '@mui/icons-material/Close';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ShareIcon from '@mui/icons-material/Share';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import Lightbox from 'yet-another-react-lightbox';
import Download from 'yet-another-react-lightbox/plugins/download';
import Share from 'yet-another-react-lightbox/plugins/share';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import type { FC } from 'react';
import type { LightboxExternalProps } from 'yet-another-react-lightbox';

interface OrderImageLightboxProps extends Omit<LightboxExternalProps, 'open'> {}

const OrderImageLightbox: FC<OrderImageLightboxProps> = ({ index, ...props }) => (
  <Lightbox
    open={(index ?? -1) >= 0}
    index={index}
    plugins={[Zoom, Download, Share]}
    zoom={{ maxZoomPixelRatio: 4 }}
    render={{
      iconDownload: () => <FileDownloadIcon />,
      iconShare: () => <ShareIcon />,
      iconClose: () => <CloseIcon />,
      iconZoomIn: () => <ZoomInIcon />,
      iconZoomOut: () => <ZoomOutIcon />,
    }}
    {...props}
  />
);

export default OrderImageLightbox;
